<template>
  <div>
    <div class="toolbtn flex">
      <switchcore></switchcore>
      <el-tooltip class="item" effect="dark" content="刷新" placement="top">
        <div @click="refresh()" class="cursorpointer margin-top10">
          <img
            src="@/assets/barsvg/icon／12sx(1).png"
            style="position: relative; top: 2px"
            alt=""
          />
          <span class="f12 pad-left5" style="color: #969eac">刷新</span>
        </div>
      </el-tooltip>
      <el-tooltip class="item" effect="dark" content="返回" placement="top">
        <callback></callback>
      </el-tooltip>
    </div>

    <!-- 检索 -->
    <div
      class="width100 f14 backwhite border-rd3 flex-betweenwrap"
      style="min-height: 72px"
      v-if="serchkey"
    >
      <el-form
        ref="ruleForm"
        size="small"
        label-width="100px"
        class="demo-ruleForm flexleft"
      >
        <el-form-item label="合同名称">
          <el-input placeholder="请输入合同名称" v-model="input"></el-input>
        </el-form-item>
        <el-form-item label="订单号">
          <el-input placeholder="请输入订单号" v-model="inputs"></el-input>
        </el-form-item>
        <div class="margin-left20 margin-top10 margin-bot10">
          <el-button type="primary" @click="submitForm()">检 索</el-button>
          <el-button @click="resetForm()">重 置</el-button>
        </div>
      </el-form>
    </div>

    <el-skeleton
      class="width100 backwhite border-rd3"
      :loading="true"
      animated
      :throttle="500"
    >
      <template slot="template">
        <div
          class="
            width100
            backwhite
            pad-bot20
            margin-auto margin-top15
            border-rd3
            alldigital
          "
          v-if="total != 0"
        >
          <el-table
            :data="page"
            stripe
            style="width: 98%"
            class="eltable margin-auto pad-top20 f14"
          >
            <el-table-column
              label="合同名称"
              align="left"
              prop="title"
              min-width="150%"
            />
            <el-table-column label="合同金额" align="center">
              <template slot-scope="scope">
                {{ scope.row.amount }} 万
              </template>
            </el-table-column>
            <el-table-column
              label="签署日期"
              align="center"
              prop="buy_set_supplier_time"
            />
            <el-table-column label="结算金额" align="center">
              <template slot-scope="scope">
                {{ scope.row.sale_settle_amount }} 万
              </template>
            </el-table-column>
            <el-table-column label="合同类型" align="center">
              <template slot-scope="scope">
                {{ scope.row.product_category.name }} /
                {{ scope.row.products.name }}
              </template>
            </el-table-column>
            <el-table-column
              label="归档日期"
              align="center"
              prop="create_time"
            />
          </el-table>
          <!-- 分页 -->
          <div
            class="flex-betweennowrap pad-top20 pad-right10"
            v-if="total != 0"
          >
            <span class="bluecolor"></span>
            <el-pagination
              :hide-on-single-page="true"
              @size-change="handleSizeChange"
              @current-change="currentchange"
              :current-page="currentPage"
              :page-sizes="[10, 20, 30, 40, 50]"
              :page-size="per_page"
              layout="total, sizes, prev, pager, next, jumper"
              :total="total"
              background
            >
            </el-pagination>
          </div>
        </div>
        <div
          class="width100 margin-auto backgroudFFF margin-top15"
          v-if="total == 0"
        >
          <el-empty
            :image="require('@/assets/barsvg/zwsj@3x.png')"
            :image-size="200"
            description="抱歉，没有搜到您想要的内容"
            class="heightempty"
            ><p style="position: relative; bottom: 60px" class="f14">
              暂无数据
            </p></el-empty
          >
        </div>
      </template>
    </el-skeleton>

    <el-dialog
      title=""
      :visible.sync="dialogVisiblenull"
      :close-on-click-modal="false"
      :show-close="true"
      :center="true"
      :modal="true"
      :modal-append-to-body="true"
      :append-to-body="true"
      width="25%"
      class="errorbox"
    >
      <p class="textalign-left f16">提示</p>
      <div class="textalign-left margin-top10">
        <span class="errormessage">{{ errormessage }}</span>
      </div>
      <span slot="footer" class="dialog-footer">
        <span @click="dialogVisiblenull = false" class="errorbutton">
          确 定
        </span>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import { companyorders } from "@/api/Center/Center.api";
import switchcore from "@/components/switchcore.vue";
import BUS from "@/BUS/BUS";
import callback from "@/components/callback.vue";
export default {
  data() {
    return {
      errormessage: "",
      dialogVisiblenull: false,
      pagination: false,
      serchkey: true,
      thisNum: 1,
      page: [],
      total: 0,
      per_page: 0,
      currentPage: 1,
      input: "",
      inputs: "",
      number: "",
    };
  },
  components: {
    callback,
    switchcore,
  },
  methods: {
    // 第一个分页
    currentchange(val) {
      this.thisNum = val;
      companyorders({
        page: val,
        _keywords: this.input,
        tech_keyword: this.inputs,
      }).then((res) => {
        if (res.data.code == 200) {
          this.pagination = true;
          this.page = res.data.data.data;
          this.total = res.data.data.total;
          this.per_page = res.data.data.per_page;
        } else {
          this.dialogVisiblenull = true;
          this.errormessage = res.data.msg;
        }
      });
    },
    handleSizeChange(val) {
      companyorders({
        page: 1,
        limit: val,
        _keywords: this.input,
        tech_keyword: this.inputs,
      }).then((res) => {
        if (res.data.code == 200) {
          this.pagination = true;
          this.page = res.data.data.data;
          this.total = res.data.data.total;
          this.per_page = res.data.data.per_page;
        } else {
          this.dialogVisiblenull = true;
          this.errormessage = res.data.msg;
        }
      });
    },
    // input重 置
    resetForm() {
      this.input = null;
      this.inputs = null;
      this.thisNum = 1;
      companyorders({
        page: this.thisNum,
      }).then((res) => {
        if (res.data.code == 200) {
          this.pagination = true;
          this.page = res.data.data.data;
          this.total = res.data.data.total;
          this.per_page = res.data.data.per_page;
        } else {
          this.dialogVisiblenull = true;
          this.errormessage = res.data.msg;
        }
      });
    },

    submitForm() {
      if (this.input != "" || this.inputs != "") {
        companyorders({
          _keywords: this.input,
          tech_keyword: this.inputs,
          page: 1,
        }).then((res) => {
          if (res.data.code == 200) {
            this.pagination = true;
            this.page = res.data.data.data;
            this.total = res.data.data.total;
            this.per_page = res.data.data.per_page;
          } else {
            this.dialogVisiblenull = true;
            this.errormessage = res.data.msg;
          }
        });
      }
    },
    refresh() {
      this.$loading.show(); // 显示loading
      companyorders({
        page: this.thisNum,
        _keywords: this.input,
        tech_keyword: this.inputs,
      }).then((res) => {
        if (res.data.code == 200) {
          this.$loading.hide(); // 隐藏loading
          this.pagination = true;
          this.page = res.data.data.data;
          this.total = res.data.data.total;
          this.per_page = res.data.data.per_page;
        } else {
          this.$loading.hide(); // 隐藏loading
          this.dialogVisiblenull = true;
          this.errormessage = res.data.msg;
        }
      });
    },
  },
  created() {
    BUS.$on("serchkey", (data) => {
      this.serchkey = data;
    });

    companyorders({
      page: this.thisNum,
    }).then((res) => {
      if (res.data.code == 200) {
        this.pagination = true;
        this.page = res.data.data.data;
        this.total = res.data.data.total;
        this.per_page = res.data.data.per_page;
      } else {
        this.dialogVisiblenull = true;
        this.errormessage = res.data.msg;
      }
    });
  },
};
</script>
<style scoped>
.eltable >>> .el-table__header-wrapper th {
  background-color: #f8f8f9;
  height: 40px;
  font-size: 13px;
}
.editor >>> .el-date-editor--daterange.el-input__inner {
  width: 100%;
}
.errorbox >>> .el-dialog__body {
  text-align: center;
}
.errorbox >>> .el-dialog {
  position: relative;
  top: 20%;
}
</style>